import { useMemo, useState } from "react";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse, Card } from "reactstrap";
import DOMPurify from "dompurify";

import styles from "Pages/Help/Support/IssueDetail.module.css";

// Used in Support.tsx to show expandable details of an issue
export default function IssueDetail({ value, description }: any) {
    const [isOpen, setIsOpen] = useState(false);

    const sanitizedDescription = useMemo(() => {
        return DOMPurify.sanitize(description);
    }, [description]);

    return (
        <div>
            {value}
            <FontAwesomeIcon
                className={styles.caretIcon}
                icon={isOpen ? faCaretUp : faCaretDown}
                onClick={() => setIsOpen(!isOpen)}
            />
            <Collapse isOpen={isOpen} className={styles.collapse}>
                <Card
                    className={styles.descriptionBox}
                    dangerouslySetInnerHTML={{
                        // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- value is DOMPurify.sanitize()'d above; the rule flags the sink unconditionally and cannot see the sanitizer.
                        __html: sanitizedDescription,
                    }}
                ></Card>
            </Collapse>
        </div>
    );
}
